import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {NavController} from '@ionic/angular/standalone';
import {Observable, catchError, throwError} from 'rxjs';
import {TranslocoService} from '@jsverse/transloco';

import {NotificationService} from '../services/notification.service';
import {PathEnum} from '../shared/enums/path-enum';
import {SKIP_FORBIDDEN_REDIRECT} from './forbidden-redirect.context';

const SKIP_403_PATTERN = /\/(login|auth|logout|token|passkey)\b/;

@Injectable()
export class Forbidden403Interceptor implements HttpInterceptor {
  constructor(
    private readonly navCtrl: NavController,
    private readonly notificationService: NotificationService,
    private readonly transloco: TranslocoService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status !== 403) {
          return throwError(() => err);
        }

        if (SKIP_403_PATTERN.test(req.url)) {
          return throwError(() => err);
        }

        // La pagina chiamante gestisce in proprio il 403 (stato `forbidden` dedicato,
        // dati preservati): non scavalcarla con toast + redirect a home, propaga e basta.
        if (req.context.get(SKIP_FORBIDDEN_REDIRECT)) {
          return throwError(() => err);
        }

        this.notificationService.openToast({
          message: this.transloco.translate('common.toast.access_forbidden'),
          color: 'warning',
          duration: 4000,
        });
        // `autoSkip`: questo rientro a home nasce da un errore HTTP, non da un gesto utente. Lo
        // dichiara al `ModalGuard` così un overlay compatibile (la notifica push) non venga
        // richiuso da un 403 di background — e soprattutto perché il guard, chiudendo un overlay,
        // NEGA la navigazione: senza il flag il rientro a home poteva non avvenire affatto.
        this.navCtrl.navigateRoot(PathEnum.PAGES + PathEnum.HOME, {replaceUrl: true, state: {autoSkip: true}});

        return throwError(() => err);
      }),
    );
  }
}
